import { render, staticRenderFns } from "./HandoverCard.vue?vue&type=template&id=623d6634"
import script from "./HandoverCard.vue?vue&type=script&lang=js"
export * from "./HandoverCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports